export default __webpack_public_path__ + "static/media/RedCliffInnMap.b0842a81.jpg";